/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":"body,html{-webkit-tap-highlight-color:transparent}"}]);
/* tslint:enable */